import type { ReactNode } from "react";
import type { ContractHistoryControls } from "./use-contract-history";
import { RunDebrief } from "./RunDebrief";
import { useVisibleRefresh } from "./use-visible-refresh";
import { credits } from "./ui-labels";
import { JournalIcon } from "./JournalIcon";
import "./contract-history.css";

export function ContractHistoryPanel({ history, busy, error, resetRequired, reload, refresh, cancel, more, latest, latestRunId, active = true }: ContractHistoryControls & { latest?: ReactNode; latestRunId?: string | undefined; active?: boolean }) {
  useVisibleRefresh(refresh, cancel, active);
  return (
    <section className="contract-history" aria-label="История контрактов" aria-busy={busy}>
      <header><h2>История вылетов</h2></header>
      <div className="contract-history-body">
      {latest}
      {error && <p role="alert">{error}</p>}
      {!history && busy && <p role="status">Загружаем историю…</p>}
      {history?.entries.length === 0 && !latest && <p>Здесь появятся результаты после первой сдачи задания.</p>}
      {history?.entries.filter(entry => !latest || entry.result.runId !== latestRunId).map(({ completedAt, result }) => (
        <details key={result.runId} className="dock-report" data-history-run={result.runId}>
          <summary>
            <JournalIcon className="journal-history-art" />
            <span>{completedAt === null ? "Ранее · дата не сохранена" : new Date(completedAt).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })} · {result.contracts.length === 0 ? "Свободный вылет" : `${result.contracts.filter(item => item.outcome === "success").length}/${result.contracts.length} выполнено`}</span>
            <span className="journal-reward"><small>Получено</small><span className="journal-amount">+{credits(result.credits)} КР</span> <span className="journal-amount">+{result.components} комп.</span></span>
            <span>{result.contracts.length === 1 ? result.contracts[0]?.terms.title : result.contracts.length === 0 ? "Итоги вылета" : `Вылет · заданий: ${result.contracts.length}`}</span>
          </summary>
          {completedAt !== null && <small className="history-completed-at">Завершён: {new Date(completedAt).toLocaleString("ru-RU")}</small>}
          <RunDebrief result={result} />
        </details>
      ))}
      {history?.nextCursor && <button disabled={busy} onClick={() => void more()}>{busy ? "Загружаем…" : "Показать ещё"}</button>}
      {error && <button disabled={busy} onClick={() => void (resetRequired ? reload() : refresh())}>{resetRequired ? "Загрузить историю заново" : "Повторить загрузку"}</button>}
      </div>
    </section>
  );
}
